import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'bulk-ingredient-toggle',

  getComponent(nextState, cb) {
    require.ensure([], require => {
      const BulkIngredientToggleContainer = require('./containers/BulkIngredientToggleContainer').default
      const bulkIngredientToggleReducer = require('./modules/bulkIngredientToggle').default

      injectReducer(store, {
        key: 'bulkIngredientToggle',
        reducer: bulkIngredientToggleReducer
      })

      cb(null, BulkIngredientToggleContainer)
    }, 'bulkIngredientToggle')
  }
})



// WEBPACK FOOTER //
// ./src/routes/BulkIngredientToggle/index.js